import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const OrgHideRepostedListingsModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "HideRepostedListingsModalContainer" */
      './OrgHideRepostedListingsModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
